module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_braveM_m2.f709a65487a7ca1d7173f4563f5de9f6.png";